
import { Component, Emit, Prop, Vue } from 'vue-property-decorator';
import { PayloadState } from '@/types/types';
import { loadWidget, findDistinctNetworks } from '@/utils/helpers';
import { KX_STATUS_COLORS } from '@/utils/statusColors';

@Component({
  name: 'LogDetailsBottomDrawerDialog',
  components: {
    EmptyPage: loadWidget('pages/EmptyPage'),
  },
  filters: {
    findDistinctNetworks,
  },
})
export default class LogDetailsBottomDrawerDialog extends Vue {
  @Prop({ required: true, default: false }) state!: boolean;
  @Prop({ default: false }) loading!: boolean;
  @Prop({ default: null }) details!: any;
  headers: { text: string; value: string; align?: string }[] = [
    {
      text: 'ID',
      value: 'messageId',
    },
    {
      text: 'Status Code',
      value: 'statusCode',
    },
    {
      text: 'Status Message',
      value: 'statusText',
    },
    {
      text: 'Error Code',
      value: 'errorCode',
    },

    {
      text: 'Error Message',
      value: 'errorMessage',
    },
    {
      text: 'From',
      value: 'from',
    },
    {
      text: 'To',
      value: 'to',
    },
  ];
  statusColors: { [key: string]: { bg: string; text: string } } = {
    pending: KX_STATUS_COLORS.pending,
    failed: KX_STATUS_COLORS.failed,
    success: KX_STATUS_COLORS.success,
  };

  @Emit('actions')
  close(state: PayloadState): PayloadState {
    return state;
  }

  @Emit('delete')
  action(): { loading: PayloadState } {
    return {
      loading: {
        state: false,
        idx: 'details',
      },
    };
  }
}
